import { render, staticRenderFns } from "./CustomerLink.vue?vue&type=template&id=2dd122f7"
import script from "./CustomerLink.vue?vue&type=script&lang=js"
export * from "./CustomerLink.vue?vue&type=script&lang=js"
import style0 from "./CustomerLink.vue?vue&type=style&index=0&id=2dd122f7&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports